export default "__VITE_ASSET__CPDMfjQc__"